import React from "react";
import { css } from "@obby/components";

export default function ClassPageHidden() {
  return (
    <>
      <div className={`class-page-hidden ${styles.classPageHidden}`}>
        <div className={`class-page-hidden__wrapper`}>
          <div className={`class-page-hidden__header ${styles.header}`}>
            <div className="container-fluid">
              <h2 className="text-center">
                This page no longer exists on Obby. Please{" "}
                <a href="/">click here</a> to go to the Obby homepage.
              </h2>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const styles = {
  classPageHidden: css({
    backgroundColor: "$pampas"
  }),
  header: css({
    display: "flex",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "white"
  })
};
